import React from 'react';
import CargomaticBreadcrumbs from 'components/v2/Breadcrumbs';
import { useGroups } from 'hooks/unifiedview/useReports';
import { usePageContext } from './PageContext';
export default function Breadcrumbs({ groupId, orderName }) {
    const { isLoading, getGroupById } = useGroups();
    const { currentPage, currentPageName, updatePage } = usePageContext();
    if (isLoading) {
        return null;
    }
    const getHref = (group) => `/unifiedview/groups/${group._id}/reports`;
    const group = getGroupById(groupId);
    const pages = group
        ? [
            Object.assign(Object.assign({}, group), { href: getHref(group) }),
        ]
        : [];
    let currentGroup = group;
    while (currentGroup === null || currentGroup === void 0 ? void 0 : currentGroup.parent) {
        const parentGroup = getGroupById(currentGroup.parent);
        pages.unshift(Object.assign(Object.assign({}, parentGroup), { href: getHref(parentGroup) }));
        currentGroup = parentGroup;
    }
    if (!groupId) {
        pages.push({
            name: currentPageName,
            href: currentPage,
        });
    }
    if (orderName) {
        pages.push({
            name: orderName,
        });
    }
    const breadcrumbs = {
        pages,
        homeUrl: '/unifiedview/reports',
        onClick: updatePage
    };
    return (React.createElement(CargomaticBreadcrumbs, { dataTestId: "CargomaticBreadcrumbs-2a6625dd", breadcrumbs: breadcrumbs, className: "mb-8" }));
}
